import React from 'react';
import GenericPopover from "@Popover/components/GenericPopover";
import datasetExtractor from "@Dataset/datasetExtractor";
import BusChangePopoverOverlay
    from "@Pages/stationToStation/features/busChangePopover/components/BusChangePopoverOverlay";
import BusChangePopoverTrigger
    from "@Pages/stationToStation/features/busChangePopover/components/BusChangePopoverTrigger";

interface BusChangePopoverProps {
    stops?: any[]
    routeId?: string,
    index?: number,
}

function BusChangePopover({stops = null, routeId = null, index}: BusChangePopoverProps) {
    const newStops = stops ?? JSON.parse(datasetExtractor('gb--bus-change', index, 'stops'))
    return (
        <GenericPopover
            id={`bus-change-popover-${index ?? routeId}`}
            overlay={<BusChangePopoverOverlay stops={newStops}/>}
            trigger={<BusChangePopoverTrigger stops={newStops}/>}
        />
    );
}

export default BusChangePopover;